// TODO:[] need to ensure label to be mandatory when its icon button
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Icon, IconColor, IconSize } from '../icon';
import { LoadingIndicator } from '../loading-indicator';
import { Typography } from '../typography';
import styles from './button.module.scss';
const buttonSizeToTypographyVariantMap = {
    xs: 'footnote',
    s: 'footnote',
    m: 'body-normal',
};
const buttonSizeToIconSizeMap = {
    xs: IconSize.XSMALL,
    s: IconSize.SMALL,
    m: IconSize.LARGE,
};
const buttonWithTextSizeToIconSizeMap = {
    xs: IconSize.SMALL,
    s: IconSize.SMALL,
    m: IconSize.MEDIUM,
};
const buttonSizeClassMap = {
    xs: styles.sizeXs,
    s: styles.sizeS,
    m: styles.sizeM,
};
const buttonRadiusClassMap = {
    leftOnly: styles.leftOnly,
    rightOnly: styles.rightOnly,
    both: styles.both,
};
const buttonBackgroundClassMap = {
    light: styles.backgroundLight,
    colored: styles.backgroundColored,
};
export const Button = ({ id, ariaLabel, text, tooltip, icon, iconPlacement = 'left', iconClassName, iconColor = IconColor.TEXT_COLOR, className, isSaving = false, isDisabled = false, isSelected = false, onClick, onDoubleClick, onKeyDown, size = 'm', type = 'primary', backgroundType = 'light', isFullWidth = false, isTextTruncated = true, borderPlacement = 'both', buttonRef, tabIndex, retainFocusOnClick = true, badgeValue = undefined, showBadge = false, ...restProps }) => {
    const buttonWrapperClassNames = cx(styles.buttonWrapper, {
        [styles.fullWidth]: isFullWidth,
    }, className);
    const buttonClassNames = cx(styles.button, {
        [styles.buttonWithIcon]: !!icon, //
        [styles.buttonWithText]: !!text,
        [styles.buttonSelected]: isSelected,
        [styles.disabled]: isDisabled,
        [styles.fullWidth]: isFullWidth,
    }, styles[type], buttonSizeClassMap[size], buttonBackgroundClassMap[backgroundType], buttonRadiusClassMap[borderPlacement]);
    const textClassNames = cx(styles.buttonText, {
        [styles.hidden]: isSaving,
        [styles.iconLeft]: !!icon && iconPlacement === 'left',
        [styles.iconRight]: !!icon && iconPlacement === 'right',
        [styles.truncateText]: isTextTruncated,
        /* Experimental style to conform with design
        this can be removed once dual intent button is moved to radiant */
        [styles.buttonWithTextAndBorderLeft]: !!text && !!icon && borderPlacement === 'leftOnly',
        [styles.buttonWithTextAndBorderRight]: !!text && !!icon && borderPlacement === 'rightOnly',
        /* Experimental style */
    });
    const iconClassNames = cx({
        [styles.hidden]: isSaving,
    });
    /**
     * this function is used to get the color of the loader, it depends on the button type
     * and button size and the button background type.
     */
    const getLoaderColor = () => {
        let loaderColor = 'gray';
        if (backgroundType === 'light') {
            if (type === 'primary') {
                loaderColor = 'white';
            }
            else if (type === 'secondary') {
                loaderColor = 'gray';
            }
            else {
                loaderColor = !!icon && !text ? 'gray' : 'blue';
            }
        }
        else {
            loaderColor = type === 'tertiary' ? 'white' : 'gray';
        }
        return loaderColor;
    };
    // Text color is fully handled by CSS via rd-sys-color() / rd-comp-color()
    // in button.module.scss — no need for inline color prop on Typography.
    // The CSS selectors (.backgroundLight .primary .buttonText, etc.) have
    // higher specificity (3 classes) than Typography's color class (1 class).
    const getIconSize = () => {
        const buttonContainsText = !!text;
        return buttonContainsText
            ? buttonWithTextSizeToIconSizeMap[size]
            : buttonSizeToIconSizeMap[size];
    };
    const renderLoader = () => {
        const loaderColor = getLoaderColor();
        return (isSaving && (React.createElement(LoadingIndicator.Contextual, { className: cx(styles.loadingSpinner), loaderColor: loaderColor })));
    };
    const renderText = () => {
        const variantName = buttonSizeToTypographyVariantMap[size];
        return (!!text && (React.createElement(Typography, { variant: variantName, className: textClassNames, 
            // No color prop — CSS handles text colors via .buttonText
            // selectors in button.module.scss for each variant/background.
            // Button margin should be respected for cases like buttons with icon/s.
            ellipsis: { rows: 1, allowMargin: true } }, text)));
    };
    const handleOnClick = (event) => {
        if (!isDisabled && onClick) {
            onClick(event);
        }
    };
    const handleOnDoubleClick = (event) => {
        if (!isDisabled && onDoubleClick) {
            onDoubleClick(event);
        }
    };
    const handleOnKeyDown = (event) => {
        if (!isDisabled && onKeyDown) {
            onKeyDown(event);
        }
    };
    return (React.createElement("div", { id: id, className: buttonWrapperClassNames, "data-tooltip-content": tooltip, "data-tooltip-position": "bottom", "data-tooltip-align": "center" },
        React.createElement("button", { type: "button", className: buttonClassNames, onClick: handleOnClick, onDoubleClick: handleOnDoubleClick, onKeyDown: handleOnKeyDown, "aria-label": ariaLabel || text, disabled: isDisabled, tabIndex: tabIndex || undefined, ref: buttonRef, onMouseLeave: (e) => {
                if (!retainFocusOnClick) {
                    e.target.blur();
                }
            }, ...restProps },
            renderLoader(),
            icon && iconPlacement === 'left' && (React.createElement(Icon, { id: icon, color: iconColor, size: getIconSize(), className: cx(iconClassNames, iconClassName) })),
            renderText(),
            icon && iconPlacement === 'right' && (React.createElement(Icon, { id: icon, color: iconColor, size: getIconSize(), className: cx(iconClassNames, iconClassName) })),
            !_.isUndefined(badgeValue) && (React.createElement("span", { className: cx(styles.badge) }, badgeValue < 100 ? badgeValue : 99)),
            showBadge && _.isUndefined(badgeValue) && (React.createElement("span", { className: cx(styles.badge, styles.dotBadge) })))));
};
//# sourceMappingURL=button.js.map